/** The market-structure direction in the page header, so the operator reads it
 * without scrolling to the status card. Structure picks the SIDE of Case 1
 * (the 50 EMA cross) only; Case 2 takes its side from the 50 EMA
 * (docs/ema_trend.md), hence the "Case 1" in the label. */

import type { ReactElement } from "react";
import { useQuery } from "@tanstack/react-query";
import { emaTrendApi } from "@/lib/emaTrendApi";
import type { Strategy } from "@/types/strategy";

const POLL_MS = 5_000;

export function EmaTrendStructurePill({
  strategy,
}: Readonly<{ strategy: Strategy }>): ReactElement | null {
  const isEma = strategy.strategy_type === "ema_trend";
  const q = useQuery({
    queryKey: ["ema-trend-status", strategy.id],
    queryFn: () => emaTrendApi.status(strategy.id),
    refetchInterval: POLL_MS,
    enabled: isEma,
  });
  if (!isEma) return null;
  const tracking = q.data?.tracking === true;
  const side = q.data?.tracking === true ? q.data.structure : null;
  const title = "Market structure (15-min) — sets the side of the 50 EMA cross trade (Case 1)";
  if (side === "LONG") {
    return (
      <span className="pill bg-success-bg text-success" title={title}>
        <i className="ti ti-trending-up text-sm" /> Structure UP
      </span>
    );
  }
  if (side === "SHORT") {
    return (
      <span className="pill bg-danger-bg text-danger" title={title}>
        <i className="ti ti-trending-down text-sm" /> Structure DOWN
      </span>
    );
  }
  return (
    <span className="pill bg-surface-2 text-ink-muted" title={title}>
      {tracking ? "Structure: no direction yet" : "Structure: engine not tracking"}
    </span>
  );
}
